import {Async, Loaded, Loading} from 'Core/models/Async';
import * as I from 'immutable';

export class UnassignedUWQuestions {
  public readonly key = 'UnassignedUWQuestions';
}

export class UWQuestionsError {
  public readonly key = 'UWQuestionsError';
}

export type question = {
  description: string;
  questionOrder: string;
  questionName: string;
};

export type UWQuestionsModel = Async<I.List<question>> | UnassignedUWQuestions | UWQuestionsError;

type MatchUWQuestionsOptions<TReturn> = {
  Loading: () => TReturn;
  Loaded: (uwQuestions: I.List<question>) => TReturn;
  Error: () => TReturn;
  Unassigned: (uwQuestions: I.List<question>) => TReturn;
  UWQuestionsError: (uwQuestions: I.List<question>) => TReturn;
};

export const isLoading = (uwQuestions: UWQuestionsModel): uwQuestions is Loading<I.List<question>> =>
  uwQuestions.key === 'Loading';

export const isLoaded = (uwQuestions: UWQuestionsModel): uwQuestions is Loaded<I.List<question>> =>
  uwQuestions.key === 'Loaded';
export const isUnassignedUWQuestions = (uwQuestions: UWQuestionsModel): uwQuestions is UnassignedUWQuestions =>
  uwQuestions.key === 'UnassignedUWQuestions';
export const isUWQuestionsError = (uwQuestions: UWQuestionsModel): uwQuestions is UWQuestionsError =>
  uwQuestions.key === 'UWQuestionsError';

export const matchUWQuestions = <TReturn>(options: MatchUWQuestionsOptions<TReturn>) => (
  uwQuestions: UWQuestionsModel
) => {
  switch (uwQuestions.key) {
    case 'UnassignedUWQuestions':
      return options.Unassigned(I.List<question>());
    case 'Loaded':
      return options.Loaded(uwQuestions.Data);
    case 'Loading':
      return options.Loading();
    case 'Conflict':
      return options.Error();
    case 'ServerError':
      return options.Error();
    case 'Unauthorized':
      return options.Error();
    case 'UWQuestionsError':
      return options.UWQuestionsError(I.List<question>());
  }
};
